// removed by extract-text-webpack-plugin
module.exports = {"content":"content___IIjUm","header":"header___T3ctc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UsageReport/UsageReport.module.css
// module id = 421
// module chunks = 0